import Question from '@/Models/ContextAndQuestions/Question';
import QuestionnaireResponse from '@/Models/Questionnaires/QuestionnaireResponse';

export default class QuestionnaireQuestion extends Question {
    constructor({ ...rest } = {}) {
        super(rest);
        // Adding aditional attrbutes
        this.questionnaireResponses = new QuestionnaireResponse();
    }
}